import React from 'react';
import Img from 'gatsby-image';
import { getFluidGatsbyImage } from 'gatsby-source-sanity';
import clientConfig from '../../../client-config';
import { Card, CardBody, CardFooter, Text, Box } from 'grommet';

export default ({ node }) => {
  if (!node || !node.asset || !node.asset._id) {
    return null;
  }
  const fluidProps = getFluidGatsbyImage(
    node.asset._id,
    { maxWidth: 1000 },
    clientConfig.sanity
  );
  return (
    <Box width="large" alignSelf="center">
      <Card round="false" margin={{ vertical: 'small' }}>
        <CardBody>
          <Img fluid={fluidProps} alt={node.alt} />
        </CardBody>
        {node.caption && (
          <CardFooter pad="small">
            <Text size="small">
              <em>{node.caption}</em>
            </Text>
          </CardFooter>
        )}
      </Card>
    </Box>
  );
};
